module.exports = __webpack_public_path__ + "media/images/social-icons/vero-5eefb9c695f417dd8497899abbd39d93.svg";